import React from 'react';

export default function Component(props) {

const { question, answersList,surveyLanguageCode, handleCheckInput, surveyScreenData, isMobile } = props;

return(
    <>
          {/* <div className="mt-4 items-center ">
            {question && question.optionsList && question.optionsList.length>0?
              question.optionsList.map((option, optionindex) =>
                <div className="flex items-center text-gray-700 font-medium mx-0 py-2"> 
                  <input type="checkbox" onClick={() => handleCheckInput(optionindex, question, option)}  
                    onChange={()=>{}}
                    checked={
                    (answersList && answersList.length > 0 && answersList
                      .findIndex(item => item.questionId === question.id) !== -1) ?
                      answersList[answersList.findIndex(item => item.questionId === question.id)].multiAnswer
                      .some(prev=>prev.optionId===option.id)?true:false:false
                  }
                  className="rounded-full w-4 h-5 rounded-full mx-4 cursor-pointer" /> 
                  <label
                  style={{color:(surveyScreenData && surveyScreenData.textColor) ? surveyScreenData.textColor : "#757575"}}
                  >{(surveyLanguageCode!=='')?
                    (question && question.transl && question.transl[surveyLanguageCode] && question.transl[surveyLanguageCode].optionsList && question.transl[surveyLanguageCode].optionsList[option.id])?
                        question.transl[surveyLanguageCode].optionsList[option.id]:option.name
                    :option.name} 
                  </label>
                </div>
            ):null}
          </div> */}



    <div className={isMobile?
    "grid grid-cols-1 py-6  lg:text-base text-sm font-normal  gap-3 mx-auto md:w-4/6 w-11/12":
    "grid grid-cols-1 ml-3 py-6  lg:text-base text-sm font-normal  gap-3 mx-auto md:w-4/6 w-11/12"}>
    
      {question && question.optionsList && question.optionsList.length>0?
        question.optionsList.map((option, optionindex) =>
          <span className=
          {
            (answersList && answersList.length > 0 && answersList
              .findIndex(item => item.questionId === question.id) !== -1) ?
              answersList[answersList.findIndex(item => item.questionId === question.id)].multiAnswer
              .some(prev=>prev.optionId===option.id)?
              " relative rounded-md border-2 p-1.5 flex items-center text-white  cursor-pointer bg-black bg-opacity-10"
              :" relative rounded-md border p-1.5 flex items-center text-white cursor-pointer bg-white bg-opacity-10 hover:bg-opacity-20"
              :" relative rounded-md border p-1.5 flex items-center text-white cursor-pointer bg-white bg-opacity-10 hover:bg-opacity-20"
            } 
          >
            <input 
            type="checkbox" 
            onClick={() => handleCheckInput(optionindex, question, option)}  
            onChange={()=>{}}
            checked={
            (answersList && answersList.length > 0 && answersList
              .findIndex(item => item.questionId === question.id) !== -1) ?
              answersList[answersList.findIndex(item => item.questionId === question.id)].multiAnswer
              .some(prev=>prev.optionId===option.id)?true:false:false
            } 
            className="w-4 h-4 mr-3 flex cursor-pointer" />
            {/* <span className="border bg-blue-500 border-white w-8 h-8 flex mr-3 rounded inline-flex items-center justify-center uppercase">a</span> */}
            <p className="truncate  w-9/12 h-8 justify-center items-center pt-2"
            style={{color:(surveyScreenData && surveyScreenData.textColor) ? surveyScreenData.textColor : "#757575"}}
            >{(surveyLanguageCode!=='')?
                    (question && question.transl && question.transl[surveyLanguageCode] && question.transl[surveyLanguageCode].optionsList && question.transl[surveyLanguageCode].optionsList[option.id])?
                        question.transl[surveyLanguageCode].optionsList[option.id]:option.name
                    :option.name} </p>
          </span>
      ):null}


    
    </div>


    </>
  );}